import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Alert from '@cloudscape-design/components/alert';
import Box from '@cloudscape-design/components/box';
import Container from '@cloudscape-design/components/container';
import Header from '@cloudscape-design/components/header';
import Spinner from '@cloudscape-design/components/spinner';
import { formatInt } from '@/features/dashboard-finance/formatters';
import { useAllTimePrintedGlobal } from './useAllTimePrintedGlobal';

/**
 * Total acumulado de etiquetas impressas em todas as empresas.
 *
 * Fica ACIMA do `PeriodControl` de propósito: é o único número da tela que
 * ignora o filtro de período, e a posição comunica isso sem precisar de
 * ressalva. Pelo mesmo motivo não reusa o `KpiCard` do `/finance`, que força
 * uma linha de variação percentual — aqui ela seria sempre "—".
 *
 * O número é o **A** (billing/BI, UTC), não o que o cliente vê no Monitor.
 * Ver `docs/label-counters.md`.
 */
export function AllTimePrintedCard(): React.JSX.Element {
  const { t } = useTranslation();
  const state = useAllTimePrintedGlobal();

  return (
    <Container header={<Header variant="h2">{t('usage.allTime.title')}</Header>}>
      {state.kind === 'LOADING' && <Spinner />}
      {state.kind === 'ERROR' && <Alert type="error">{t('usage.allTime.error')}</Alert>}
      {state.kind === 'READY' && (
        <>
          <Box variant="awsui-key-label">{t('usage.allTime.label')}</Box>
          <Box variant="h1">{formatInt(state.total)}</Box>
          <Box variant="small" color="text-status-inactive">
            {t('usage.allTime.helper')}
          </Box>
        </>
      )}
    </Container>
  );
}
